import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGV4ZWN1dGl2ZSUyMG1lZXRpbmclMjBkYXJrJTIwdGhlbWV8ZW58MHx8fHwxNzgzNTc3NzU4fDA&ixlib=rb-4.1.0&q=85";

export const Approach = () => {
  const { t } = useLang();
  return (
    <section id="approach" className="relative py-24 md:py-32 bg-[#0A0A0B]" data-testid="approach-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-end mb-16 md:mb-24">
          <div className="md:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-gold" />
                <span className="flo-label">{t.approach.label}</span>
              </div>
              <h2 className="font-serif-display text-white text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.98] max-w-2xl">
                {t.approach.title}
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-5">
            <Reveal delay={0.15}>
              <div className="relative overflow-hidden rounded-lg aspect-[4/3] border border-white/10">
                <img src={IMG} alt="" className="w-full h-full object-cover opacity-70 hover:scale-105 transition-transform duration-[1.5s] ease-out" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B] via-transparent to-transparent" />
              </div>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 md:gap-y-24">
          {t.approach.chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08} className="relative pl-2">
              <span className="absolute -top-10 md:-top-14 left-0 font-serif-display text-[7rem] md:text-[9rem] leading-none text-white/[0.05] select-none pointer-events-none">
                {c.n}
              </span>
              <div className="relative pt-6 border-t border-white/10">
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-serif-display text-gold text-lg">{c.n}</span>
                  <h3 className="font-serif-display text-white text-2xl md:text-3xl tracking-tight">{c.t}</h3>
                </div>
                <p className="text-zinc-400 leading-relaxed max-w-md">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
